import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

const moduleEquipmentStatus = {
  namespaced: true,

  state: {
    name: 'EquipmentStatus',
    nextSeqCode: null,
    equipmentStatuses: [],
  },

  mutations,
  getters,
  actions
}

export default moduleEquipmentStatus;